module.exports = __webpack_public_path__ + "img/abstract-shapes-17.baeb5497.svg";